// extracted by mini-css-extract-plugin
export var lg = "_el-7";
export var md = "_el-6";
export var placeholderContainer = "_el-1";
export var placeholderIcon = "_el-2";
export var productImage = "_el-0";
export var sm = "_el-5";
export var xl = "_el-8";
export var xs = "_el-4";
export var xxs = "_el-3";